import { css } from '@emotion/react';

export const dialogBody = css`
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const tags = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const description = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
